<template>
  <div id="data">
    <img
      :src="require('../assets/ltLogo.svg')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
    <img
      :src="require('../assets/smsNewLogo.png')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
    <img
      :src="require('../assets/smsLogo.png')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
    <img
      :src="require('../assets/mete.png')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
    <img
      :src="require('../assets/meteFB.png')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
    <img
      :src="require('../assets/happy_birthday.png')"
      width="100%"
      height="100%"
      alt="metaImg"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
